export class Simulator {
  constructor() {
    this._section = document.querySelector('.s-simulator')
    if (!this._section) return

    this._results = this._section.querySelector('.s-simulator-results')
    if (!this._results) return

    this._calcValues = { cremant: 0, blanc: 0, rouge: 0 }
    this._finalTextSnapshot = []
    this._hideResults = false
    this._resultsShown = false
    this._intervalId = null

    this.init()
  }

  init() {
    this._startTracking()
    this._listenForSubmit()

    const restartBtn = this._results.querySelector('[data-simulator-restart]')
    if (restartBtn) {
      restartBtn.addEventListener('click', () => this._reset())
    }
  }

  _reset() {
    const wrapper = this._section.querySelector('.s-simulator-wrapper')
    if (wrapper) wrapper.style.display = ''

    this._results.setAttribute('aria-hidden', 'true')
    this._results.style.display = 'none'
    const resultsBox = this._results.querySelector('.s-simulator-results__wrapper')
    if (resultsBox) resultsBox.style.display = ''

    this._resultsShown = false
    this._calcValues = { cremant: 0, blanc: 0, rouge: 0 }
    this._finalTextSnapshot = []
    this._hideResults = false

    const cremantEl = this._results.querySelector('[data-result="cremant"]')
    const blancEl = this._results.querySelector('[data-result="blanc"]')
    const rougeEl = this._results.querySelector('[data-result="rouge"]')
    if (cremantEl) cremantEl.textContent = '0'
    if (blancEl) blancEl.textContent = '0'
    if (rougeEl) rougeEl.textContent = '0'

    clearInterval(this._intervalId)
    this._intervalId = setInterval(() => this._capture(), 300)

    const forminatorContainer = this._section.querySelector('.forminator-ui')
    if (forminatorContainer) {
      const successOutput = forminatorContainer.querySelector('.forminator-response-output--success, .forminator-thankyou')
      if (successOutput) {
        successOutput.style.display = 'none'
      }
      const formEl = forminatorContainer.querySelector('form.forminator-form')
      if (formEl) {
        const formRows = forminatorContainer.querySelectorAll('.forminator-row')
        formRows.forEach((row) => { row.style.display = '' })
        formEl.reset()
        const firstStep = forminatorContainer.querySelector('.forminator-pagination-steps .forminator-step')
        if (firstStep) {
          forminatorContainer.querySelectorAll('.forminator-step').forEach((s) => s.classList.remove('forminator-current'))
          firstStep.classList.add('forminator-current')
          const stepsContainer = forminatorContainer.querySelector('.forminator-pagination-steps')
          if (stepsContainer) stepsContainer.setAttribute('data-current-step', '1')
        }
      }
      if (window.jQuery) {
        window.jQuery(forminatorContainer).trigger('forminator:form:reset')
      }
    }
  }

  _startTracking() {
    this._intervalId = setInterval(() => this._capture(), 300)

    const form = this._section.querySelector('.forminator-ui')
    if (form) {
      form.addEventListener('change', () => this._capture())
      form.addEventListener('input', () => this._capture())

      new MutationObserver(() => {
        if (this._resultsShown) return
        this._captureFinalTexts()
      }).observe(form, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      })
    }

    const submitBtn = this._section.querySelector('.forminator-btn-submit')
    if (submitBtn) {
      submitBtn.addEventListener('click', () => this._capture())
    }
  }

  _listenForSubmit() {
    if (window.jQuery) {
      window.jQuery(document).on('forminator:form:submit:success', () => {
        if (!this._resultsShown) {
          // this._capture()
          this._showResults()
        }
      })
    }

    const container = this._section.querySelector('.forminator-ui')
    if (container) {
      new MutationObserver(() => {
        if (this._resultsShown) return
        if (container.querySelector('.forminator-response-output--success, .forminator-thankyou')) {
          // this._capture()
          this._showResults()
        }
      }).observe(container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      })
    }
  }

  _capture() {
    this._calcValues.cremant = this._getValue('calculation-10')
    this._calcValues.rouge = this._getValue('calculation-11')
    this._calcValues.blanc = this._getValue('calculation-12')
    this._captureFinalTexts()
  }

  _captureFinalTexts() {
    const snapshot = []
    let hideResults = false

    this._section.querySelectorAll('.final-text').forEach((el) => {
      if (!el.classList.contains('forminator-hidden') && !el.closest('.forminator-hidden')) {
        if (el.classList.contains('final-text-without-result')) {
          hideResults = true
        }
        const field = el.querySelector('.forminator-field')
        if (field) {
          snapshot.push(field.innerHTML)
        }
      }
    })

    this._finalTextSnapshot = snapshot
    this._hideResults = hideResults
  }

  _getValue(id) {
    const input = document.querySelector(`input[name="${id}"]`)
    return input ? parseFloat(input.value) || 0 : 0
  }

  _showResults() {
    this._resultsShown = true
    clearInterval(this._intervalId)

    const cremantEl = this._results.querySelector('[data-result="cremant"]')
    const blancEl = this._results.querySelector('[data-result="blanc"]')
    const rougeEl = this._results.querySelector('[data-result="rouge"]')

    if (cremantEl) cremantEl.textContent = this._calcValues.cremant
    if (blancEl) blancEl.textContent = this._calcValues.blanc
    if (rougeEl) rougeEl.textContent = this._calcValues.rouge

    const endpointEl = this._results.querySelector('[endpoint-final-text]')
    if (endpointEl && this._finalTextSnapshot.length > 0) {
      endpointEl.innerHTML = this._finalTextSnapshot.join('')
    }

    const wrapper = this._section.querySelector('.s-simulator-wrapper')
    if (wrapper) wrapper.style.display = 'none'

    if (this._hideResults) {
      this._results.removeAttribute('aria-hidden')
      this._results.style.display = 'flex'
      const resultsBox = this._results.querySelector('.s-simulator-results__wrapper')
      if (resultsBox) resultsBox.style.display = 'none'
    } else {
      this._results.removeAttribute('aria-hidden')
      this._results.style.display = 'flex'
    }
  }
}
